<template>
  <div class="row no-gutters">
    <div class="col-6">
      <v-text-field
        max="3"        
        v-model="addr.fsa"
        placeholder="FSA"
        @input="onFSA"
        :outlined="outlined"
        :dense = "dense"
      />
    </div>
    <div class="col-6">
      <v-text-field
        max="3"       
        v-model="addr.ldu"
        placeholder="LDU"
        @input="onLDU"
        :outlined="outlined"
        :dense = "dense"
      />
    </div>
    <div
      class="col-12 red--text"
      v-if="msg"
      v-b-tooltip.hover.bottom
      :title="$t('messages.PostalCodeHint')"
    >
      <i class="fas fa-exclamation-triangle"></i>
        <span>{{$t('errors.InvalidPostalCodeFormat')}}</span> 
    </div>
  </div>
</template>

<script>
import dataSvc from "@/services/dataService";
export default {
  props: {
    AddressID: {
      type: Number,
      required: true
    },
    FSA: {
      type: String
    },
    LDU: {
      type: String
    },
    outlined:{
      type:Boolean
    },
    dense:{
      type:Boolean
    },
    isRequired:{
      type:Boolean
    }
  }, 
  data() {
    return {
      fsaHandler: null,
      lduHandler: null,
      msg: null,
      addr: {
        fsa: null,
        ldu: null
      }
    };
  },
  methods: {
    onPostalFsaKeyUp() {
      this.$nextTick(() => {
        if(this.addr.fsa === null){
          return;
        }
        
        this.addr.fsa = this.addr.fsa.toUpperCase();
        this.$emit("OnFSAChange", this.addr.fsa);
      });

      if (this.addr.fsa.length == 3) {
        $(".d_" + this.AddressID + "_PostalLdu>input").focus();
      }
    },
    onPostalLduKeyUp() {
      this.$nextTick(() => {
         if(this.addr.ldu === null){
          return;
        }
        
        this.addr.ldu = this.addr.ldu.toUpperCase();
         this.$emit("OnLDUChange", this.addr.ldu);
      });
    },
    validEmit() {
      if(!this.addr.fsa || !this.addr.ldu)
        return;
      let postData = {
        FSA: this.addr.fsa,
        LDU: this.addr.ldu
      };
      dataSvc
        .getHttp()
        .post("public/IsValidPostalCode", postData)
        .then(res => {
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.msg = null;
          } else {
            this.msg = res.data.ReturnStatus.ReturnMessage;
          }
        });
    },
    onFSA() {
      this.msg = null;
      this.onPostalFsaKeyUp();      
      if (this.fsaHandler) clearTimeout(this.fsaHandler);      
      this.fsaHandler = setTimeout(() => {
        this.validEmit();
      }, 900);
    },
    onLDU() {
      this.msg = null;
      this.onPostalLduKeyUp();
     
      if (this.fsaHandler) clearTimeout(this.fsaHandler);
      this.fsaHandler = setTimeout(() => {
        this.validEmit();
      }, 900);
    }
  },
  watch: {
    FSA: {
      handler(n) {
        this.addr.fsa = n;
        this.validEmit();
      },
      deep: false,
      immediate: true
    },
    LDU: {
      handler(n) {
        this.addr.ldu = n;
        this.validEmit();
      },
      deep: false,
      immediate: true
    }
  }
};
</script> 